const POST_LOGIN_REDIRECT_KEY = 'post-login-redirect-path';

function isSafeAppPath(path: string): boolean {
  if (!path || typeof path !== 'string') return false;
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//')) return false;
  if (path.includes('://')) return false;
  return true;
}

export function setPostLoginRedirect(path: string): void {
  if (typeof window === 'undefined') return;
  if (!isSafeAppPath(path)) return;
  try {
    localStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
  } catch {
    // ignore storage errors
  }
}

export function getPostLoginRedirect(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const value = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (!value || !isSafeAppPath(value)) return null;
    return value;
  } catch {
    return null;
  }
}

export function consumePostLoginRedirect(): string | null {
  const value = getPostLoginRedirect();
  if (typeof window !== 'undefined') {
    try {
      localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    } catch {
      // ignore storage errors
    }
  }
  return value;
}
